import { NavLink } from "react-router-dom";
import { LayoutDashboard, Users, History, Activity } from "lucide-react";
import { CAT_ICONS, GROUP_LABEL } from "../lib/icons";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-3 py-2 text-sm border-l-2 transition-colors ${
    isActive
      ? "border-[#38bdf8] bg-gradient-to-r from-[#0ea5e9]/20 to-transparent text-white shadow-[inset_0_0_0_1px_rgba(56,189,248,0.08)]"
      : "border-transparent text-[#bfdbfe]/65 hover:text-white hover:bg-[#0ea5e9]/[0.08]"
  }`;

export const Sidebar = ({ meta, user, onNavigate }) => {
  const groups = ["Sarpras", "Almatsus", "Polda"];
  const cats = meta?.categories || [];
  return (
    <div className="relative h-full flex flex-col cyber-hero text-white overflow-hidden border-r border-[#1e3a8a]/70">
      <div className="cyber-grid absolute inset-0 opacity-60 pointer-events-none" />
      <div className="absolute -bottom-24 -left-16 h-64 w-64 rounded-full bg-[#2563eb]/20 blur-3xl pointer-events-none" />
      <div className="relative h-16 px-5 flex items-center gap-3 border-b border-[#1e3a8a]/70">
        <img src="/logo-siber.png" alt="Logo Siber Polri" className="h-10 w-auto drop-shadow-[0_0_10px_rgba(56,189,248,0.45)]" data-testid="sidebar-logo" />
        <div className="leading-tight">
          <div className="font-heading font-black text-sm tracking-tight">SILOG <span className="text-[#38bdf8]">SIBER</span></div>
          <div className="text-[10px] text-[#7dd3fc]/60 uppercase tracking-wider">Subbagrenmin Dittipidsiber</div>
        </div>
      </div>
      <nav className="relative flex-1 overflow-y-auto py-4 space-y-5">
        <div>
          <NavLink to="/dashboard" className={linkCls} onClick={onNavigate} data-testid="nav-dashboard">
            <LayoutDashboard className="h-4 w-4" /> Dashboard Rekap
          </NavLink>
        </div>
        {groups.map((g) => {
          const list = cats.filter((c) => c.group === g);
          if (!list.length) return null;
          return (
            <div key={g}>
              <div className="px-4 mb-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-[#7dd3fc]/50">{GROUP_LABEL[g]}</div>
              {list.map((c) => {
                const Icon = CAT_ICONS[c.key];
                return (
                  <NavLink key={c.key} to={`/data/${c.key}`} className={linkCls} onClick={onNavigate} data-testid={`nav-${c.key}`}>
                    <Icon className="h-4 w-4 shrink-0" />
                    <span className="leading-tight">{c.label}{c.unit && <span className="block text-[10px] text-[#7dd3fc]/55">{c.unit}</span>}</span>
                  </NavLink>
                );
              })}
              {g === "Polda" && user?.role !== "polda" && (
                <NavLink to="/status-polda" className={linkCls} onClick={onNavigate} data-testid="nav-status-polda">
                  <Activity className="h-4 w-4" /> Status Pengisian
                </NavLink>
              )}
            </div>
          );
        })}
        <div>
          <div className="px-4 mb-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-[#7dd3fc]/50">Administrasi</div>
          <NavLink to="/riwayat" className={linkCls} onClick={onNavigate} data-testid="nav-riwayat">
            <History className="h-4 w-4" /> Riwayat Perubahan
          </NavLink>
          {user?.role === "admin" && (
            <NavLink to="/users" className={linkCls} onClick={onNavigate} data-testid="nav-users">
              <Users className="h-4 w-4" /> Pengguna & Akses
            </NavLink>
          )}
        </div>
      </nav>
      <div className="relative p-4 border-t border-[#1e3a8a]/70 text-[11px] font-mono text-[#7dd3fc]/50">
        <span className="inline-block h-1.5 w-1.5 mr-2 rounded-full bg-[#22d3ee] shadow-[0_0_6px_#22d3ee]" />Sistem internal &middot; tidak untuk publik
      </div>
    </div>
  );
};
